import {Route} from '@angular/router';
import {irbAuthenticationGuard} from '@irb/irb-authentication/irb-authentication.guard';
import {irbNavigationGuard} from '@irb-common/modules/main-menu/main-menu.navigation.guard';
import {developmentGuard} from "@irb-common/modules/main-menu/main-menu.development.guard";
import {irbOrdersGuard} from "@irb/irb-orders/irb-orders.guard";

export const ROUTES: Route[] = [
  {
    path: '',
    loadChildren: () => import('./irb-authentication/irb-authentication.module').then(m => m.IrbAuthenticationModule)
  },
  {
    path: 'initial-setup',
    loadChildren: () => import('./irb-initial-setup/irb-initial-setup.module').then(m => m.IrbInitialSetupModule),
    canActivate: [irbAuthenticationGuard],
    runGuardsAndResolvers: 'always'
  },
  {
    path: 'home',
    loadChildren: () => import('./irb-dashboard/irb-dashboard.module').then(m => m.IrbDashboardModule),
    canActivate: [irbAuthenticationGuard],
    canDeactivate: [irbNavigationGuard],
    runGuardsAndResolvers: 'always'
  },
  {
    path: 'gs-securities',
    loadChildren: () => import('./irb-settings/irb-settings.module').then(m => m.IrbSettingsModule),
    canActivate: [irbAuthenticationGuard],
    canDeactivate: [irbNavigationGuard]
  },
  {
    path: 'reports',
    loadChildren: () => import('./irb-reports/irb-reports.module').then(m => m.IrbReportsModule),
    canActivate: [irbAuthenticationGuard],
    canDeactivate: [irbNavigationGuard],
    runGuardsAndResolvers: 'always'
  },
  {
    path: 'clients',
    loadChildren: () => import('./irb-clients/irb-clients.module').then(m => m.IrbClientsModule),
    canActivate: [irbAuthenticationGuard],
    canDeactivate: [irbNavigationGuard],
    runGuardsAndResolvers: 'always'
  },
  {
    path: 'models',
    loadChildren: () => import('./irb-models/irb-models.module').then(m => m.IrbModelsModule),
    canActivate: [irbAuthenticationGuard],
    canDeactivate: [irbNavigationGuard],
    runGuardsAndResolvers: 'always'
  },
  {
    path: 'rebalancing',
    loadChildren: () => import('./irb-rebalance/irb-rebalance.module').then(m => m.IrbRebalanceModule),
    canActivate: [irbAuthenticationGuard],
    canDeactivate: [irbNavigationGuard]
  },
  {
    path: 'orders',
    loadChildren: () => import('./irb-orders/irb-orders.module').then(m => m.IrbOrdersModule),
    canActivate: [irbAuthenticationGuard, irbOrdersGuard],
    canDeactivate: [irbNavigationGuard],
    runGuardsAndResolvers: 'always'
  },
  {
    path: 'ui',
    loadChildren: () => import('./irb-ui/irb-ui.module').then(m => m.IrbUiModule),
    canActivate: [developmentGuard, irbAuthenticationGuard],
    canDeactivate: [irbNavigationGuard]
  },
  {
    path: 'healthcheck',
    redirectTo: 'home'
  },
  {
    path: '**',
    redirectTo: ''
  }
];
